/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Highlight_Starter_TeamsInputs */



/**
* | output |
* | --- |
* | "Teams & collaboration" |
*
* @param {Plan_Gate_Highlight_Starter_TeamsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_highlight_starter_teams = /** @type {((inputs?: Plan_Gate_Highlight_Starter_TeamsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Highlight_Starter_TeamsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Teams & Zusammenarbeit")
	return /** @type {LocalizedString} */ ("Teams & collaboration")
});